module.exports = __webpack_public_path__ + "static/media/Restore.fbd3cb32.jpg";